import { createTheme } from '@mui/material/styles';

export const createAppTheme = (darkMode: boolean) => {
  return createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
      primary: {
        main: '#8b5cf6',
      },
      secondary: {
        main: '#dc004e',
      },
      ...(darkMode
        ? {
            background: {
              default: '#0d1220',
              paper: '#141a2a',
            },
          }
        : {}),
    },
    typography: {
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
      ].join(','),
      h1: {
        fontSize: '2rem',
        '@media (max-width:600px)': {
          fontSize: '1.75rem',
        },
      },
      h2: {
        fontSize: '1.75rem',
        '@media (max-width:600px)': {
          fontSize: '1.5rem',
        },
      },
      h3: {
        fontSize: '1.5rem',
        '@media (max-width:600px)': {
          fontSize: '1.25rem',
        },
      },
      h4: {
        fontSize: '1.25rem',
        '@media (max-width:600px)': {
          fontSize: '1.125rem',
        },
      },
      h5: {
        fontSize: '1.125rem',
        '@media (max-width:600px)': {
          fontSize: '1rem',
        },
      },
      h6: {
        fontSize: '1rem',
        '@media (max-width:600px)': {
          fontSize: '0.875rem',
        },
      },
      body1: {
        fontSize: '0.9375rem',
        '@media (max-width:600px)': {
          fontSize: '0.875rem',
        },
      },
      body2: {
        fontSize: '0.8125rem',
        '@media (max-width:600px)': {
          fontSize: '0.75rem',
        },
      },
    },
    components: {
      MuiButton: {
        defaultProps: {
          disableRipple: false,
        },
        styleOverrides: {
          root: {
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: 8,
            '@media (max-width:600px)': {
              fontSize: '0.875rem',
              padding: '8px 16px',
            },
            transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
          },
        },
      },
      MuiTable: {
        defaultProps: {
          size: 'small',
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: '6px 8px',
            fontSize: '0.8125rem',
            '@media (max-width:600px)': {
              padding: '6px 4px',
              fontSize: '0.75rem',
            },
          },
          head: {
            fontWeight: 700,
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: 0.4,
            color: 'text.secondary',
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            fontWeight: 600,
            borderRadius: 6,
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms !important',
            willChange: 'transform',
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          root: {
            '& .MuiBackdrop-root': {
              transition: 'opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            },
          },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            '&:hover': {
              backgroundColor: 'action.hover',
              transition: 'background-color 100ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            },
            '&.no-transition': {
              transition: 'none',
              '&:hover': {
                transition: 'none',
              },
            },
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            '@media (max-width:600px)': {
              '& .MuiInputBase-input': {
                fontSize: '16px',
              },
            },
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            '@media (max-width:600px)': {
              padding: '12px',
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: 12,
          },
        },
      },
    },
  });
};


